<div class="tree-container">
  <p-tree *ngIf="isDashboardPage" [value]="dataSource" selectionMode="single" [(selection)]="selectedNode"
      (onNodeSelect)="selectedNodeChange($event.node)" scrollHeight="600px">
    <ng-template let-node pTemplate="default">
      <div fxLayout="row" fxLayoutAlign="start center" [ngClass]="{'highlight-selected-node': node.data.pGroupValue.id === selectedNode.data.pGroupValue.id}">
        <mat-icon *ngIf="node.data.pGroupValue.type === treeNodeTypes.root"> business</mat-icon>
        <mat-icon *ngIf="node.data.pGroupValue.type === treeNodeTypes.group">library_books</mat-icon>
        <strong [ngClass]="{'asset-text': (node?.data.pGroupValue.type === 'leaf')}">{{node.label}}</strong>
      </div>
    </ng-template>
  </p-tree>
</div>